import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Panel from '../../controls/Panel';
import NavLink from '../../controls/NavLink';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Button from '../../controls/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withSnackbar } from 'notistack';

const styles = (theme) => ({
    panel: {
        textAlign: 'center',
    },
    content: {
        marginTop: theme.spacing(6),
    },
    contentSpacer: {
        ...theme.mixins.toolbar,
        marginTop: theme.spacing(3),
    },
    actionBar: {
        marginTop: theme.spacing(6),
    },
    footer: {
        marginTop: theme.spacing(6),
    },
    formControl: {
        minWidth: 250,
    },
    actionButton: {
        marginLeft: 10,
        marginRight: 10,
    },
});

class FormName extends React.Component {
    state = {
        name: '',
        validFormName: true,
    };

    startForm = () => {
        if (this.state.name) {
            this.setState({
                validFormName: true,
            });
            this.props.onStartNew(this.state.name, (variant) => {
                if (variant === 'success') {
                    this.props.history.push(`/form/${this.props.form.id}`);
                }
                this.handleOpenSnackbar(variant);
            });
        } else {
            this.setState({
                validFormName: false,
            });
        }
    };

    handleOpenSnackbar = (variant) => {
        const message = variant === 'success' ? 'Saved successfully!' : 'Your form could not be saved';
        this.props.enqueueSnackbar(message, {
            variant: variant,
            action: (key) => (
                <IconButton
                    key={key}
                    aria-label={key}
                    color="inherit"
                    size="small"
                    onClick={() => this.props.closeSnackbar(key)}
                >
                    <CloseIcon />
                </IconButton>
            ),
        });
    };

    handleChange = (event) => {
        const name = event.target.value;
        this.setState({
            name: name,
        });
    };

    render() {
        return (
            <Grid container justifyContent="center">
                <Grid item xs={12} md={9} lg={6}>
                    <div className={this.props.classes.contentSpacer} />
                    <Panel className={this.props.classes.panel}>
                        <Typography variant="h6">What is the name of your form?</Typography>
                        <div className={this.props.classes.content}>
                            <FormControl variant="outlined">
                                <TextField
                                    id="formName"
                                    onChange={this.handleChange}
                                    error={!this.state.validFormName && !this.state.name}
                                    helperText={
                                        !this.state.validFormName && !this.state.name
                                            ? 'Form must be named before saving'
                                            : ''
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className={this.props.classes.actionBar}>
                            <Button
                                variant="contained"
                                onClick={this.startForm}
                                className={this.props.classes.actionButton}
                            >
                                Save
                            </Button>
                        </div>
                        <div className={this.props.classes.footer}>
                            <NavLink to="/">Return to Dashboard</NavLink>
                        </div>
                    </Panel>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles(styles)(withSnackbar(FormName)));
